import * as React from "react";
import {
  ArrayInput,
  AutocompleteInput,
  Create,
  CreateProps,
  ReferenceInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
  useTranslate,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";

const ServicesCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();
  const translate = useTranslate();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <span>{translate("services.cover")}</span>
        <ImageCropInput
          slot="serviceCover"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="cover"
        />
        <ReferenceInput source="banner" reference="banners">
          <AutocompleteInput
            fullWidth
            label="services.banner"
            optionText={`bannerSubtitle.${locale}`}
          />
        </ReferenceInput>

        <ArrayInput source="forms" label="services.forms">
          <SimpleFormIterator fullWidth>
            <ReferenceInput source="form" reference="forms">
              <AutocompleteInput
                fullWidth
                label="services.form"
                optionText={`formSubtitle.${locale}`}
              />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput
            fullWidth
            source="serviceName"
            label="services.serviceName"
          />
          <TextInput
            fullWidth
            source="coverTitle"
            label="services.coverTitle"
          />
          <TextInput
            fullWidth
            source="coverSubTitle"
            label="services.coverSubTitle"
          />
          <TextInput
            fullWidth
            source="mainPriceTitle"
            label="services.mainPriceTitle"
          />
          <TextInput
            fullWidth
            source="mainPriceSubtitle"
            label="services.mainPriceSubtitle"
          />
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};

export default ServicesCreate;
